import axios from '../utils/axios/axiosApi'
import moment from 'moment'
import { UseDateTime } from '../hooks/useDateTime'

function getData () { 
    const user = JSON.parse(localStorage.getItem('user'))
    return ({
        DocumentNumber : user.DocumentNumber, 
        DocumentType : user.DocumentTypeDes, 
        PaymentProvider : "PaymentPortal",
        NetworkOwner : "POR",
        TransactionDate : moment(new Date()).format('DDMMYYYY')
    })
};

function getDataToAddPaymentProduct (total, products, paymentTicket, payLoad, typeTransaction) {
    const user = JSON.parse(localStorage.getItem('user'))
    
    return ({
        PaymentTicket: paymentTicket,
        DocumentNumber : user.DocumentNumber, 
        DocumentTypeId : user.DocumentType,
        DocumentTypeDes : user.DocumentTypeDes,
        Payload : JSON.stringify(payLoad) !== undefined ? JSON.stringify(payLoad): "INTERNAL ERROR",
        TypeTransaction: typeTransaction,
        ProductDetail: products
    })
}

const getProductsAsync = () => {
    return new Promise((resolve, reject) => {
        axios.post('Payment/GetPendingPaymentByDocument', getData())
             .then((response) => {
                response.data.Products.map(document => {
                    var date = document.ExpirationDate.split(' ')
                    var initial = date[0].split(/\//).reverse().join('/');
                    var policyDocumentNumber = document.ReferenceDesc.split('-')
                    var endorsementNumber = policyDocumentNumber[2].split('_')
                    document.ExpirationDate = UseDateTime(initial,"DD/MM/YYYY")
                    document.Locked = response.data.Products.filter(
                        x => (x.ReferenceDesc.includes(endorsementNumber[0])) && parseInt(x.ReferenceDesc.split('-')[3].split('_')[2]) < parseInt(policyDocumentNumber[3].split('_')[2])).length > 0;
                    if(!document.Locked) {
                        document.Locked = response.data.Products.filter(
                            x => (x.ReferenceDesc.includes(endorsementNumber[0])) && parseInt(x.ReferenceDesc.split('-')[2].split('_')[2]) < parseInt(endorsementNumber[2])).length > 0;
                    }
                })
                resolve(response.data);
             })
             .catch((error) => {
                reject(error);
             });
    });
};

const addPaymentProductAsync = (total, products, paymentTicket, payload, typeTransaction) => { 
    return new Promise((resolve, reject) => {
        axios.post('ProductPortal/AddTransaction', getDataToAddPaymentProduct(total, products, paymentTicket, payload, typeTransaction))
             .then((response) => {
                resolve(response)
             })
             .catch((error) => {
                reject(error);
             });
    })
};

const getTransactionAsync = paymentId => {
    return new Promise((resolve, reject) => {
        axios.get(`Payment/GetPSEPaymentStatus/${paymentId}`)
             .then((response) => {
                resolve(response);
             })
             .catch((error) => {
                reject(error);
             });
    });
};
    
const sendMail = transactionInfo => { 
    return new Promise((resolve, reject) => {
        axios.post('ProductPortal/SendEmail', transactionInfo)
             .then((response) => {
                resolve(response)
             })
             .catch((error) => {
                reject(error);
             });
    })
};

export {
    getProductsAsync,
    addPaymentProductAsync,
    getTransactionAsync,
    sendMail
}